module.exports = __webpack_public_path__ + "img/img3.e7bd524b.jpg";